import React, { type ComponentPropsWithoutRef, type ReactNode } from 'react';

import classnames from 'classnames';

import { BreadcrumbProvider, type BreadcrumbContextType } from '../../Breadcrumb.context';

import styles from './BreadcrumbRoot.module.scss';

type BreadcrumbRootProps = {
    className?: string;
    breadcrumb: BreadcrumbContextType;
    children?: ReactNode;
} & ComponentPropsWithoutRef<'nav'>;

export const BreadcrumbRoot = ({
    className,
    children,
    breadcrumb,
    ...rest
}: BreadcrumbRootProps) => {
    return (
        <BreadcrumbProvider value={breadcrumb}>
            <nav
                className={classnames(styles.container, className)}
                aria-label="Breadcrumb"
                {...rest}
            >
                {children}
            </nav>
        </BreadcrumbProvider>
    );
};
